// Moved to components/Table/DataTable — nothing here was comments-specific.
//
// The copy that lived here predated the shared table and drifted in three ways, all
// of which the shared one already handles or fixes: it keyed cells and headers on
// Math.random() (so every render threw the rows away and rebuilt them), it made every
// header clickable regardless of the `sortable` flag the container already sets on each
// column, and it took a `handleClick` prop it never used.
export { default } from '../../Table/DataTable';
